import React from "react";
import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import CheckCircle from "@material-ui/icons/CheckCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

export default function EnableDisableIconButton(props) {
	const { tooltipTitleEnable, tooltipTitleDisable, onClick, status } = props;
	const classes = useStyles();
	return (
		<IconButton className={`${!status ? classes.check : classes.reject} ${classes.iconButton}`} onClick={onClick}>
			<Tooltip title={status ? tooltipTitleDisable : tooltipTitleEnable} aria-label="active">
				{status ? <HighlightOffIcon /> : <CheckCircle />}
			</Tooltip>
		</IconButton>
	);
}

const useStyles = makeStyles((theme) => ({
	check: {
		"&:hover": {
			"& svg": {
				fill: "#22D3C5",
			},
		},
	},
	reject: {
		"&:hover": {
			"& svg": {
				fill: "#FF619A",
			},
		},
	},
	iconButton: {
		"& svg": {
			fill: theme.palette.primary.main,
		},
	},
}));
